import React from 'react';
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { Edit as EditIcon, Archive as ArchiveIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import PrimaryActionButton from '../common/PrimaryActionButton';
import { BRAND } from '../../theme/brandTokens';

const SuppliersPanel = ({ suppliers = [], canManage = false, onCreate, onEdit, onArchive }) => {
  const { t } = useTranslation();
  const visible = suppliers.filter((supplier) => !supplier.isArchived);

  return (
    <Box id="suppliers-panel" sx={{ p: { xs: 2, sm: 3 } }}>
      {canManage ? (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <PrimaryActionButton id="create-supplier" onClick={onCreate}>
            {t('stock.suppliers.create')}
          </PrimaryActionButton>
        </Box>
      ) : null}
      <Box sx={{ overflowX: 'auto', border: `1px solid ${BRAND.line}`, borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: BRAND.background }}>
              <TableCell>{t('stock.suppliers.name')}</TableCell>
              <TableCell>{t('stock.suppliers.phone')}</TableCell>
              <TableCell>{t('stock.suppliers.email')}</TableCell>
              {canManage ? <TableCell align="right" /> : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {visible.length === 0 ? (
              <TableRow>
                <TableCell colSpan={canManage ? 4 : 3}>
                  <Typography variant="body2" color="text.secondary">{t('stock.suppliers.empty')}</Typography>
                </TableCell>
              </TableRow>
            ) : visible.map((supplier) => (
              <TableRow key={supplier.id}>
                <TableCell>{supplier.name}</TableCell>
                <TableCell>{supplier.phone}</TableCell>
                <TableCell>{supplier.email}</TableCell>
                {canManage ? (
                  <TableCell align="right">
                    <Tooltip title={t('stock.suppliers.edit')}>
                      <IconButton aria-label={t('stock.suppliers.edit')} onClick={() => onEdit(supplier)} sx={{ color: BRAND.accentText }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={t('stock.suppliers.archive')}>
                      <IconButton aria-label={t('stock.suppliers.archive')} onClick={() => onArchive(supplier)} sx={{ color: 'error.main' }}>
                        <ArchiveIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                ) : null}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default SuppliersPanel;
